'use client';

import dynamic from 'next/dynamic';

export const Sovendus = dynamic(
  () => import(/* webpackChunkName: 'Sovendus' */ './Sovendus.client').then((mod) => mod.Sovendus),
  {
    ssr: false,
  },
);
